// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.ctf-row + .ctf-row[data-v-f0e7c048] {\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n.ctf-input[data-v-f0e7c048] {\n    width: 120px;\n}\n.ctf-input[data-v-f0e7c048] input {\n    text-align: right;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
